import { CheckboxProps } from '@chakra-ui/checkbox';
import { Checkbox, CheckboxGroup, Stack, StackProps, Text } from '@chakra-ui/react';
import { SelectOption } from '@pelicargo/types';
import { Show } from '@pelicargo/ui';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

type Props = StackProps & {
  name: string;
  options: SelectOption[];
  label?: string;
  checkboxProps?: CheckboxProps;
};

export const SimpleCheckboxGroup = ({ name, label, options, checkboxProps, ...rest }: Props) => {
  const selectedOptions: string[] = useWatch({ name });
  const { setValue } = useFormContext();

  const onCheckboxChange = useCallback(
    (nextValue: string[]) => {
      setValue(name, nextValue);
    },
    [name, setValue],
  );

  const renderOption = useCallback(
    ({ label, value }) => {
      return (
        <Checkbox key={value} value={value} size="lg" {...checkboxProps}>
          <Stack direction="row" align="center">
            <Text>{label}</Text>
          </Stack>
        </Checkbox>
      );
    },
    [checkboxProps],
  );

  return (
    <Stack {...rest}>
      <Show if={!!label}>
        <Text textStyle="caption">{label}</Text>
      </Show>
      <CheckboxGroup colorScheme="blue" value={selectedOptions} onChange={onCheckboxChange}>
        {options.map(renderOption)}
      </CheckboxGroup>
    </Stack>
  );
};
